/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatchBasicUserInformationRequest } from '../../models/patch-basic-user-information-request';
import { UserInformation } from '../../models/user-information';

export interface PatchBasicUser$Params {
      body: PatchBasicUserInformationRequest
}

export function patchBasicUser(http: HttpClient, rootUrl: string, params: PatchBasicUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInformation>> {
  const rb = new RequestBuilder(rootUrl, patchBasicUser.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserInformation>;
    })
  );
}

patchBasicUser.PATH = '/users';
